export default __webpack_public_path__ + "static/okremote_1-8051ef11690e5c17349250fcd2ccd237.jpg";